import axios from 'axios';

// Determine the API base URL based on environment
const getApiBaseUrl = () => {
  const currentHost = window.location.hostname;
  const currentProtocol = window.location.protocol;
  
  // If running on localhost, use the local API server
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return 'http://localhost:3010/api';
  }
  
  // For production (prismdash.ai or any other domain), use the same domain with /api
  return `${currentProtocol}//${currentHost}/api`;
};

const baseURL = getApiBaseUrl();

// Create axios instance with base configuration
const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 second timeout for large datasets
});

// Request interceptor for error handling
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
